export default __webpack_public_path__ + "static/media/arrowBottom.ff202b74.svg";